module.exports = __webpack_public_path__ + "static/img/zengjia.8c47c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zengjia.png
// module id = fWDt
// module chunks = 24